import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function CadastroVisita() {
  const [visita, setVisita] = useState({
    id: null,
    familia_id: '',
    cultura_id: '',
    ano: new Date().getFullYear(),
    quantidade_produzida: '',
    unidade: ''
  });
  const [visitas, setVisitas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [culturas, setCulturas] = useState([]);
  const [editId, setEditId] = useState(null);
  const [mensagem, setMensagem] = useState(null);

  // Carregar produções da API ao inicializar
  useEffect(() => {
    fetch(`${API_BASE_URL}/producao_familia/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de produções recebidos:', data);
        setVisitas(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('❌ Erro ao buscar produções.'));
  }, []);

  // Carregar famílias da API ao inicializar
  useEffect(() => {
    fetch(`${API_BASE_URL}/familias/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de famílias recebidos:', data);
        setFamilias(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('❌ Erro ao buscar famílias.'));
  }, []);

  // Carregar culturas da API ao inicializar
  useEffect(() => {
    fetch(`${API_BASE_URL}/culturas/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de culturas recebidos:', data);
        setCulturas(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('❌ Erro ao buscar culturas.'));
  }, []);

  // Função para obter o nome da família pelo ID
  const getNomeFamilia = (familia_id) => {
    if (!familia_id) return '-';
    const familia = familias.find(f => f.id === familia_id || f.id === parseInt(familia_id));
    return familia ? familia.nome_responsavel : 'Família não encontrada';
  };

  // Função para obter o nome da cultura pelo ID
  const getNomeCultura = (cultura_id) => {
    if (!cultura_id) return '-';
    const cultura = culturas.find(c => c.id === cultura_id || c.id === parseInt(cultura_id));
    return cultura ? cultura.nome : 'Cultura não encontrada';
  };

  const handleChange = e => {
    setVisita({ ...visita, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (editId) {
      // Atualizar produção existente
      try {
        console.log('Atualizando produção:', { id: editId, ...visita });
        const res = await fetch(`${API_BASE_URL}/producao_familia/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editId,
            familia_id: visita.familia_id,
            cultura_id: visita.cultura_id,
            ano: visita.ano,
            quantidade_produzida: visita.quantidade_produzida,
            unidade: visita.unidade
          })
        });
        
        console.log('Resposta da atualização:', res.status);
        
        if (res.ok) {
          // Atualizar a produção na lista local
          // Preserva a data_cadastro original
          const producaoAntiga = visitas.find(v => v.id === editId);
          const producaoAtualizada = {
            id: editId,
            familia_id: visita.familia_id,
            cultura_id: visita.cultura_id,
            ano: visita.ano,
            quantidade_produzida: visita.quantidade_produzida,
            unidade: visita.unidade,
            data_cadastro: producaoAntiga && producaoAntiga.data_cadastro ? producaoAntiga.data_cadastro : undefined
          };
          setVisitas(visitas.map(v => (v.id === editId ? producaoAtualizada : v)));
          setMensagem('✅ Produção atualizada com sucesso!');
          setEditId(null);
          setVisita({ id: null, familia_id: '', cultura_id: '', ano: new Date().getFullYear(), quantidade_produzida: '', unidade: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na atualização:', errorData);
          setMensagem('❌ Erro ao atualizar produção.');
        }
      } catch (error) {
        console.error('Erro ao atualizar produção:', error);
        setMensagem('❌ Erro ao atualizar produção.');
      }
    } else {
      // Criar nova produção
      try {
        console.log('Criando nova produção:', visita);
        const res = await fetch(`${API_BASE_URL}/producao_familia/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            familia_id: visita.familia_id,
            cultura_id: visita.cultura_id,
            ano: visita.ano,
            quantidade_produzida: visita.quantidade_produzida,
            unidade: visita.unidade
          })
        });
        
        console.log('Resposta da criação:', res.status);
        
        if (res.ok) {
          const result = await res.json();
          console.log('Resultado da criação:', result);
          
          // Buscar a produção recém cadastrada pelo id retornado
          if (result && result.productId) {
            try {
              const resProducao = await fetch(`${API_BASE_URL}/producao_familia/${result.productId}`);
              const producaoData = await resProducao.json();
              console.log('Dados da produção criada:', producaoData);
              
              if (producaoData && Array.isArray(producaoData.producao_familia) && producaoData.producao_familia.length > 0) {
                setVisitas([...visitas, producaoData.producao_familia[0]]);
              } else {
                // Fallback: adicionar com os dados locais
                const novaProducao = {
                  id: result.productId,
                  familia_id: visita.familia_id,
                  cultura_id: visita.cultura_id,
                  ano: visita.ano,
                  quantidade_produzida: visita.quantidade_produzida,
                  unidade: visita.unidade
                };
                setVisitas([...visitas, novaProducao]);
              }
            } catch (fetchError) {
              console.error('Erro ao buscar produção criada:', fetchError);
              // Fallback: adicionar com os dados locais
              const novaProducao = {
                id: result.productId,
                familia_id: visita.familia_id,
                cultura_id: visita.cultura_id,
                ano: visita.ano,
                quantidade_produzida: visita.quantidade_produzida,
                unidade: visita.unidade
              };
              setVisitas([...visitas, novaProducao]);
            }
          }
          setMensagem('✅ Produção cadastrada com sucesso!');
          setVisita({ id: null, familia_id: '', cultura_id: '', ano: new Date().getFullYear(), quantidade_produzida: '', unidade: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na criação:', errorData);
          setMensagem('❌ Erro ao cadastrar produção.');
        }
      } catch (error) {
        console.error('Erro ao cadastrar produção:', error);
        setMensagem('❌ Erro ao cadastrar produção.');
      }
    }
  };

  const handleEdit = (id) => {
    const v = visitas.find(v => v.id === id);
    if (v) {
      setVisita({ 
        id: v.id,
        familia_id: v.familia_id || '',
        cultura_id: v.cultura_id || '',
        ano: v.ano || new Date().getFullYear(),
        quantidade_produzida: v.quantidade_produzida || '',
        unidade: v.unidade || ''
      });
      setEditId(id);
      setMensagem(null);
      console.log('Editando produção:', v);
    } else {
      setMensagem('❌ Produção não encontrada para edição.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta produção?')) {
      return;
    }

    try {
      console.log('Deletando produção com ID:', id);
      const res = await fetch(`${API_BASE_URL}/producao_familia/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      
      console.log('Resposta da API delete:', res.status);
      
      if (res.ok) {
        setVisitas(visitas.filter(v => v.id !== id));
        setMensagem('✅ Produção removida com sucesso!');
        if (editId === id) {
          setEditId(null);
          setVisita({ id: null, familia_id: '', cultura_id: '', ano: new Date().getFullYear(), quantidade_produzida: '', unidade: '' });
        }
      } else {
        const errorData = await res.text();
        console.error('Erro ao deletar:', errorData);
        setMensagem('❌ Erro ao remover produção.');
      }
    } catch (error) {
      console.error('Erro ao deletar produção:', error);
      setMensagem('❌ Erro ao remover produção.');
    }
  };

  return (
    <div className="page-content" style={{maxWidth: 1500, margin: 0, padding: '0 32px', width: '100%'}}>
      <div className="cadastro-produtor-container" style={{background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: '2rem 0', width: '100%', maxWidth: '100%'}}>
        <h2>Cadastro de Produção Familiar</h2>
        <div style={{display: 'flex', gap: 32, alignItems: 'flex-start', flexWrap: 'wrap'}}>
        <div className="cadastro-form"
          style={{
            flex: 1,
            minWidth: 300,
            maxWidth: 600,
            flexBasis: 0,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }}>
          <form onSubmit={handleSubmit} style={{width: '100%', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <fieldset >
              <legend>Dados da Produção</legend>
              <label htmlFor="familia_id">Família</label>
              <select id="familia_id" name="familia_id" value={visita.familia_id} onChange={handleChange} required>
                <option value="">Selecione</option>
                {familias.map(f => (
                  <option key={f.id} value={f.id}>{f.nome_responsavel}</option>
                ))}
              </select>

              <label htmlFor="cultura_id">Cultura</label>
              <select id="cultura_id" name="cultura_id" value={visita.cultura_id} onChange={handleChange} required>
                <option value="">Selecione</option>
                {culturas.map(c => (
                  <option key={c.id} value={c.id}>{c.nome}</option>
                ))}
              </select>

              <label htmlFor="ano">Ano</label>
              <input 
                id="ano" 
                name="ano" 
                type="number" 
                min="2020" 
                max="2030" 
                value={visita.ano} 
                onChange={handleChange} 
                required 
              />

              <label htmlFor="quantidade_produzida">Quantidade Produzida</label>
              <input id="quantidade_produzida" name="quantidade_produzida" type="number" step="0.01" value={visita.quantidade_produzida} onChange={handleChange} required />

              <label htmlFor="unidade">Unidade</label>
              <input id="unidade" name="unidade" value={visita.unidade} onChange={handleChange} placeholder="Ex: kg, ton, l" maxLength={10} required />
            </fieldset>
            <button type="submit" className="btn-cadastrar">{editId ? 'Atualizar' : 'Cadastrar'}</button>
            {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
          </form>
        </div>
        <div
          style={{
            flex: 1,
            minWidth: 300,
            maxWidth: 900,
            flexBasis: 0,
            width: '100%',
            marginTop: 0,
            background: '#fff',
            borderRadius: 8,
            boxShadow: '0 2px 8px #0001',
            border: '1px solid #e0e0e0',
            padding: 24
          }}>
          <h3>Últimas 5 Produções Cadastradas</h3>
          <p style={{margin: '0 0 12px 0', color: '#555', fontSize: 14}}>
            A tabela abaixo mostra apenas as 5 produções mais recentemente cadastradas no sistema, considerando o maior ID como o mais novo.
          </p>
          <div style={{width: '100%', overflowX: 'auto'}}>
            <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'auto'}}>
              <thead>
                <tr>
                  <th>Família</th>
                  <th>Cultura</th>
                  <th>Ano</th>
                  <th>Quantidade</th>
                  <th>Unidade</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {visitas
                  .slice()
                  .sort((a, b) => b.id - a.id)
                  .slice(0, 5)
                  .map(v => (
                    <tr key={v.id}>
                      <td>{getNomeFamilia(v.familia_id)}</td>
                      <td>{getNomeCultura(v.cultura_id)}</td>
                      <td>{v.data_cadastro ? new Date(v.data_cadastro).getFullYear() : v.ano}</td>
                      <td>{v.quantidade_produzida}</td>
                      <td>{v.unidade}</td>
                      <td>
                        <div style={{display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap'}}>
                          <button onClick={() => handleEdit(v.id)} className="btn-acao" style={{flex: 1, minWidth: 80, maxWidth: 120}}>Editar</button>
                          <button onClick={() => handleDelete(v.id)} className="btn-acao excluir" style={{flex: 1, minWidth: 80, maxWidth: 120}}>Excluir</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                {visitas.length === 0 && (
                  <tr><td colSpan={6} style={{textAlign: 'center', color: '#888'}}>Nenhuma produção cadastrada.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
